module.exports = __webpack_public_path__ + "img/CS-ECO13_Overview.2412941a.jpg";